<template>
  <div class="page flex-col align-center">
    <div class="menuRow flex-row" v-if="zmPartner">
      <div class="menu_label">切换商户：</div>
      <div class="menu_value" @click="changePartner">{{ currentPartner }}</div>
    </div>
    <div class="menuRow flex-row">
      <div class="menu_label">回复状态：</div>
      <div class="menu_value" @click="changeCommentStatus">{{ currentCommentStatus }}</div>
    </div>
    <span style="padding: 10px">当前查询到<span class="comment_number">{{ comment_number }}</span> 条评论</span>
    <div class="commentList flex-col align-center" v-if="comments.length !== 0">
      <div class="commentItem flex-col" v-for="item of comments" :key="item.comment.id">
        <div class="commentRow flex-row justify-between">
          <span class="comment_label">用户：</span>
          <div class="flex-row align-center">
            <img :src="item.comment.comment.userImg" class="userImg" alt="">
            <span class="comment_value" style="font-size: 12px;padding: 5px">{{ item.comment.comment.nickName }}</span>
          </div>
        </div>
        <div class="commentRow flex-row justify-between">
          <span class="comment_label">userId：</span>
          <span class="comment_value" style="font-size: 14px">{{ item.comment.userAccount }}</span>
        </div>
        <div class="commentRow flex-row justify-between">
          <span class="comment_label">评分：</span>
          <van-rate color="rgba(165, 206, 100, 1)" v-model="item.comment.comment.rate"
                    gutter="2" :size="17"
                    void-icon="star" void-color="#eee" />
        </div>
        <div class="commentRow flex-row justify-between">
          <span class="comment_label" style="white-space: nowrap">评论内容：</span>
          <div class="comment_comment flex-col">
            <span class="comment_text">{{ item.comment.comment.comment }}</span>
            <div class="imgBox flex-row flex-wrap justify-start"
                 v-if="item.comment.comment.imgUrls && item.comment.comment.imgUrls.length > 0">
              <van-image-preview class="comment_img"
                                 v-model="showImg"
                                 :images="item.comment.comment.imgUrls" />
              <img class="comment_img"
                   v-for="(img,index) of item.comment.comment.imgUrls"
                   :key="index"
                   :src="img"
                   @click="showImgPreview(item.comment.comment.imgUrls,index)"
                   alt="" />
            </div>
          </div>
        </div>
        <div class="commentRow flex-row justify-between">
          <span class="comment_label">评论时间：</span>
          <span class="comment_value">{{ item.comment.createTime }}</span>
        </div>
        <div class="commentRow flex-row justify-between" v-if="item.comment.orderId">
          <span class="comment_label">订单：</span>
          <span class="comment_value">{{ item.comment.orderId }}</span>
        </div>
        <div class="commentRow flex-row justify-between" v-if="item.comment.orderId">
          <span class="comment_label">产品：</span>
          <div class="comment_value" v-if="item.comment.comment.product && item.comment.comment.product.length !== 0">
            <div class="flex_col" v-for="product of item.comment.comment.product" :key="product.id">
              <span>{{ product.name }}：{{ product.price }}元</span>
            </div>
          </div>
        </div>
        <div class="commentRow flex-row justify-between">
          <span class="comment_label">门店：</span>
          <span class="comment_value">{{ item.comment.posName }}</span>
        </div>
        <div class="commentRow flex-row justify-between">
          <span class="comment_label">posId：</span>
          <span class="comment_value">{{ item.comment.posId }}</span>
        </div>
        <div class="commentRow flex-row justify-between">
          <span class="comment_label">回复状态：</span>
          <span class="comment_value" :style="getReplyStatusColor(item.comment.adminProcessStatus)">{{
              getReplyStatus(item.comment.adminProcessStatus)
            }}</span>
        </div>
        <div class="commentRow flex-row justify-between">
          <span class="comment_label">回复记录：</span>
          <div class="comment_text flex-col" style="max-width: 80%;"
               v-if="item.replyList && item.replyList.length !== 0">
            <div class="comment_reply_container flex-row" v-for="(reply,index) of item.replyList" :key="reply.id">
              <span class="flex-row align-start" style="font-weight: bolder">
                <span>{{ index + 1 }}</span>
                <span style="margin: 0 3px 0 2px">.</span>
              </span>
              <span class="comment_reply">{{ reply.comment.replyContent }}</span>
            </div>
          </div>
        </div>
        <div class="commentRow" v-if="item.comment.adminProcessStatus === 0">
          <el-button style="width: 100%" type="primary" plain @click="toModCommentStatus(item)">忽略此评论</el-button>
        </div>

        <div class="commentRow">
          <div class="flex-row align-center">
            <el-input class="comment_reply_input" v-model="item.replyContent" placeholder="回复用户"></el-input>
            <button class="recordButton" @click="replyComment(item)">回复评论</button>
          </div>
        </div>

        <div class="commentRow">
          <recode-button
            :currentComment="item"
            :saveRecordComment="saveRecordComment"
            :getRecordText="getRecordText"
          >
          </recode-button>
        </div>

      </div>
    </div>
    <div class="no_comments_yet_container justify-center" v-else>
      <span class="no_comments_yet">暂无评论</span>
    </div>

    <load-more :loadMore="loadMore"></load-more>
  </div>
</template>

<script>
import {
  findPartnerByPartnerId,
  getPartnerDetailList,
  queryCommentByAdminHandleState,
  queryCommentPosInfo
} from "../graphql/api";
import {ImagePreview} from "vant";
import {modCommentStatus, replyUserComment} from "../api";
import RecodeButton from "../components/recodeButton.vue";
import {watchScroll} from "../util";
import LoadMore from "../components/loadMore.vue";

export default {
  name: "comments_reply",
  components: {
    LoadMore,
    RecodeButton
  },
  data() {
    return {
      comments: [],  //评论列表
      comment_number: 0,
      page: 1,
      anonymous_user: "https://static.nationaiot.com/source/zmxcl_assets/picture/anonymous_user.png",
      showImg: false,
      replyContent: "",
      processStatusList: [0],

      partnerList: [],
      posList: "",
      commentStatus: [{
        label: "所有",
        value: 3
      }, {
        label: "无需处理",
        value: -1
      }, {
        label: "未处理",
        value: 0
      }, {
        label: "已处理",
        value: 1
      }, {
        label: "已拒绝",
        value: 2
      }],

      zmPartner: false,
      currentPartner: "",
      partnerId: null,
      currentPos: "",
      currentCommentStatus: "未处理",

      currentComment: null,//回复的评论

      loadMore: true,
    }
  },
  mounted() {
    this.getPartner();
    this.getComments();
    this.pagingQuery();
  },
  destroyed() {
    this.destroyPagingQuery();
  },
  methods: {

    //展示图片预览图
    showImgPreview(imgUrls, index) {
      ImagePreview({
        images: imgUrls,
        startPosition: index,
      });
    },

    // 获取当前商户
    getPartner() {
      let partnerid = sessionStorage.getItem('partnerid');
      if(partnerid === 'M2022060601') {
        this.zmPartner = true;
        this.getPartnerList();
      }else{
        this.zmPartner = false;
        this.partnerId = partnerid;
      }
    },

    // 查询商户列表
    getPartnerList() {
      let params = {
        stateList: [1,2]
      }
      getPartnerDetailList(params).then(res => {
        console.log('所有商家列表', res.data.queryPartner);
        let data = res.data.queryPartner;
        for(const item of data) {
          let partner = {
            label: item.name,
            value: item.id,
            partnerId: item.partnerId
          }
          this.partnerList.push(partner)
        }
        this.partnerList.unshift({
          label: "所有",
          value: "000",
          partnerId: null
        })
        this.currentPartner = "所有";

        console.log('this.partnerList', this.partnerList);
      }).catch(error => {
        alert(`查询商户列表异常:${error}`)
      })
    },

    // 查询评论
    getComments() {
      console.log('查询评论');
      let params = {
        processStatusList: this.processStatusList,
        partnerId: this.partnerId,
        page: this.page,
        size: 20,
      }
      this.loadMore = false;
      queryCommentByAdminHandleState(params).then(res => {
        let data = res.data.findCommentAndReplyByProcessStatus
        if (data && Array.isArray(data)) {
          if(data.length === 20){
            this.loadMore = true
          }
          for (const item of data) {
            if (typeof item.comment.comment === 'string') {
              item.comment.comment = JSON.parse(item.comment.comment);
              let {nickName, userImg} = item.comment.comment;
              if (typeof nickName === 'string' && nickName.length === 0) {
                item.comment.comment.nickName = "匿名用户";
              }
              if (typeof userImg === 'string' && userImg.length === 0) {
                item.comment.comment.userImg = this.anonymous_user;
              }
            }
            if (item.replyList && item.replyList.length !== 0) {
              for (const reply of item.replyList) {
                if (typeof reply.comment === 'string') {
                  reply.comment = JSON.parse(reply.comment);
                }
              }
            }

            this.queryPosInfo(item, item.comment.posId);

            item.replyContent = "";

            this.comments.push(item);
            this.comment_number = this.comments.length;
          }
          console.log('评论列表', this.comments);
        }
      }).catch(error => {
        alert(`查询评论异常:${error}`)
      })
    },

    // 根据posId查询网点信息
    queryPosInfo(item, posId) {
      queryCommentPosInfo(posId).then(res => {
        if (res.data.findPosInfoByPosId) {
          this.$set(item.comment, "posName", res.data.findPosInfoByPosId.pos.name)
        } else {
          this.$set(item.comment, "posName", "");
        }
      }).catch(error => {
        alert(`查询网点信息有误${error}`);
      })
    },

    // 回复评论
    replyComment(item) {
      const {sessionId, id, userAccount} = item.comment;
      const {replyContent} = item;
      if (replyContent !== '' || replyContent.replace(/^\s*|\s*$/g, "") !== "") {
        let params = {
          sessionId: sessionId,
          commentType: 2,
          parentId: id,
          commentJson: JSON.stringify({
            replyContent: replyContent
          }),
          toUserAccount: userAccount
        }
        replyUserComment(params).then(res => {
          console.log('回复评论成功', res);
          if (res.data.retcode == 0) {
            this.$toast({
              icon: "success",
              message: "回复评论成功"
            })
            this.changeShowState()
            this.getComments();
          } else {
            console.log('回复评论失败', res.data.retmsg);
          }
        }).catch(error => {
          console.log('回复评论失败', error);
        })
      } else {
        this.$dialog.alert({
          title: "提醒",
          message: "请输入回复内容",
        })
      }
    },

    // 获取回复状态
    getReplyStatus(item) {
      const replyStatusMap = {
        "-1": "无需处理",
        "0": "未处理",
        "1": "已处理",
        "2": "已拒绝"
      }

      return replyStatusMap[item];
    },

    // 获取回复状态颜色
    getReplyStatusColor(item) {
      const replyStatusColorMap = {
        "-1": "color: #909399",
        "0": "color: #F56C6C",
        "1": "color: #67C23A",
        "2": "color: #409EFF"
      }

      return replyStatusColorMap[item];
    },

    // 更新页面缓存
    changeShowState() {
      this.page = 1;
      this.comments = [];
      this.replyContent = ""
    },

    // 变更商户
    changePartner() {
      let that = this;
      this.$weui.picker(
        that.partnerList,
        {
          className: 'custom-classname',
          container: 'body',
          defaultValue: ["000"],
          onConfirm: function (result) {
            console.log(result);
            that.currentPartner = result[0].label;
            that.partnerId = result[0].partnerId;
            that.page = 1;
            that.comment_number = 0;
            that.comments = [];
            that.getComments()
          },
          id: 'singleLinePicker'
        }
      )
    },

    // 变更查询的评论回复状态
    changeCommentStatus() {
      let that = this;
      this.$weui.picker(
        this.commentStatus,
        {
          className: 'custom-classname',
          container: 'body',
          defaultValue: [0],
          onConfirm: function (result) {
            console.log(result);
            that.currentCommentStatus = result[0].label;
            that.changeStatusQueryComments(result[0]);
          },
          id: 'singleLinePicker'
        }
      )
    },

    // 回复状态改变后查询评论列表
    changeStatusQueryComments(item) {
      const processStatusListMap = {
        "-1": [-1],
        "0": [0],
        "1": [1],
        "2": [2],
        "3": [-1, 0, 1, 2]
      }
      this.processStatusList = processStatusListMap[item.value];
      this.changeShowState();
      this.getComments();
    },

    // 修改评论的状态
    toModCommentStatus(item) {
      this.$dialog.alert({
        title: "提醒",
        message: "确认忽略此评论吗？",
        showCancelButton: true,
      }).then(res => {
        let params = {
          id: item.comment.id,
          adminProcessStatus: 2
        }
        modCommentStatus(params).then(res => {
          if (res.data.retcode == 0) {
            this.$toast({
              icon: "success",
              message: "忽略评论成功！"
            });
            this.changeShowState();
            this.getComments();
          } else {
            alert(`忽略评论失败：${res.data.retmsg}`);
          }
        }).catch(error => {
          alert(`修改评论状态${error}`)
        })
      })
    },

    // 保存录音时的操作的评论
    saveRecordComment(item) {
      this.currentComment = item;
    },

    // 提取录制的语音文字
    getRecordText(text) {
      for (const item of this.comments) {
        if (item.comment.id === this.currentComment.comment.id) {
          item.replyContent = text;
        }
      }
    },

    // 加载更多
    pagingQuery() {
      window.addEventListener('scroll', (e) => {
        watchScroll(e, this.loadMoreComments)
      }, true)
    },

    // 销毁分页监听
    destroyPagingQuery() {
      window.removeEventListener('scroll', (e) => {
        console.log('销毁监听');
        watchScroll(e, this.loadMoreComments)
      }, true)
    },

    // 加载更多
    loadMoreComments() {
      if(this.loadMore){
        console.log('加载更多');
        this.page++;
        this.getComments();
      }
    },
  }
}
</script>

<style src="../css/comments_reply.css" scoped>
</style>



// WEBPACK FOOTER //
// src/views/comments_reply.vue